import React from 'react';

import BrandShow from '@shared/brands/BrandShow';
import { useLoaderData } from 'react-router-dom';

import brandService from '@services/admin/brandService';

const AdminBrandShow: React.FC = () => {
  const brand = useLoaderData() as React.ComponentProps<typeof BrandShow>['brand'];

  return (
    <BrandShow
      brand={brand}
      brandService={brandService}
      role="admin"
      basePath="/brands"
    />
  );
};

export default AdminBrandShow;
